import { render, staticRenderFns } from "./WebsiteOrderList.vue?vue&type=template&id=19cf52c0&scoped=true&"
import script from "./WebsiteOrderList.vue?vue&type=script&lang=js&"
export * from "./WebsiteOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf52c0",
  null
  
)

export default component.exports